<template>
<div>
  <div class="fd-menuSub" v-if="menuList.length > 0">
    <el-menu :default-active="path" class="el-menu-vertical-demo" :unique-opened="true">
      <template  v-for="(item,index) in menuList">
          <el-menu-item v-if="!item.children" :key="index" :index="item.menuUrl" @click="handleJump(item)">
            <span slot="title" style="font-size:18px">{{item.menuName}}</span>
          </el-menu-item> 
          <el-submenu v-if="item.children" :key="index" :id="'topid' + index" :index="item.menuUrl" >
            <template slot="title">
              <span>{{item.menuName}}</span>
            </template>
            <el-menu-item-group v-for="(itemt, indext) of item.children" :key="indext">
              <el-menu-item :index="itemt.menuUrl" :id="'top' + index+'-'+indext" @click="handleJump(itemt)">{{itemt.menuName}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
      </template>
      
    </el-menu>
  </div>
  <div v-else style="color:#fff">暂无数据</div>  
  <!-- <div v-if="menuList.length > 0" class="fd-menuSub">
    <el-menu
      :default-active="path"
      class="el-menu-vertical-demo"
      unique-opened="true">
      <el-submenu v-for="(item, index) of menuList" :key="index" :id="'topid' + index" :index="item.menuUrl" >
        <template slot="title">
          <span>{{item.menuName}}</span>
        </template>
        <el-menu-item-group v-for="(itemt, indext) of item.children" :key="indext">
          <el-menu-item :index="itemt.menuUrl" :id="'top' + index+'-'+indext" @click="handleJumpt(itemt)">{{itemt.menuName}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div> -->
</div>
</template>
<script>
import router from '../router';
export default {
  props: {
    menuList: {
      type: Array,
    },
    router,
    path: {
      type: String,
    },
  },
  data(){
    return{
      openNav: ['1-0'],
    }
  },
  methods: {
    handleJump(item) {
      //debugger
      localStorage.setItem('menuList', JSON.stringify(this.menuList));
      this.$router.push({
        path: item.menuUrl,
        query: {
          columnCode: item.menuCode,
          path:item.menuUrl
        },
      });
    }
  },
};
</script>
<style>
.fd-left-menu {
  /* width: 240.16px; */
  background: #fff;
  border-radius: 6px;
}
.fd-left-menu .el-menu-item.is-active {
  color: #303133;
  font-weight: 700;
  background: rgba(24, 128, 255, 0.1);
  border-left: 2px solid #409eff;
}
.fd-left-menu .el-menu {
  background: transparent;
  border: none;
}
.fd-left-menu .el-menu-item,
.fd-left-menu .el-submenu__title {
  height: auto;
  line-height: normal;
  /* margin-top: 12px; */
  /* margin-bottom: 16px; */
  color: #303133;
  width: 100%;
  float: left;
  margin-right: 10%;
  padding: 8px 5px;
  padding-left: 0 !important;
  white-space: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/leftMenu.vue